import { render, staticRenderFns } from "./BemVindo.vue?vue&type=template&id=33cc2f96&"
import script from "./BemVindo.vue?vue&type=script&lang=js&"
export * from "./BemVindo.vue?vue&type=script&lang=js&"
import style0 from "./BemVindo.vue?vue&type=style&index=0&id=33cc2f96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports